export default __webpack_public_path__ + "static/media/other-weather.451c3ed9.svg";